import {
  AddParkingServiceImageRequest,
  CreateParkingServiceCTARequest,
  CreateParkingServiceRequest,
  GetParkingServiceImageRequest,
  RemoveParkingServiceCTARequest,
  RemoveParkingServiceImageRequest,
  UpdateParkingServiceMetadataRequest,
  UpdateParkingServiceOperationHoursRequest,
  UpdateParkingServiceParkingRatesRequest,
  UpdateParkingServiceParkingSpacesRequest,
  UpdateParkingServicePaymentMethodsRequest,
  UpdateParkingServiceStoreIdsRequest,
  UpdateParkingServiceTagsRequest,
} from './requests/parking-service-request.ts';
import { apiClient } from './client.tsx';
import {
  AddParkingServiceImageResponse,
  CreateParkingServiceCTAResponse,
  CreateParkingServiceResponse,
  DisableParkingServiceResponse,
  EnableParkingServiceResponse,
  GetParkingServiceImageResponse,
  GetParkingServiceResponse,
  PauseParkingServiceResponse,
  RemoveParkingServiceCTAResponse,
  RemoveParkingServiceImageResponse,
  RemoveParkingServiceOperationHoursResponse,
  UpdateParkingServiceMetadataResponse,
  UpdateParkingServiceOperationHoursResponse,
  UpdateParkingServiceParkingRatesResponse,
  UpdateParkingServiceParkingSpacesResponse,
  UpdateParkingServicePaymentMethodsResponse,
  UpdateParkingServiceStoreIdsResponse,
  UpdateParkingServiceTagsResponse,
} from './responses/parking-service-response.ts';

export const createParkingService = (request: CreateParkingServiceRequest) =>
  apiClient
    .post<CreateParkingServiceResponse>('/v2/parking_services', request)
    .then((res) => res.data.data);

export const updateParkingServiceMetadata = (
  request: UpdateParkingServiceMetadataRequest,
) =>
  apiClient
    .put<UpdateParkingServiceMetadataResponse>(
      `/v2/parking_services/${request.serviceId}`,
      request,
    )
    .then((res) => res.data.data);

export const getParkingService = (serviceId: string) =>
  apiClient
    .get<GetParkingServiceResponse>(`/v2/parking_services/${serviceId}`)
    .then((res) => res.data.data);

export const createParkingServiceCTA = (
  request: CreateParkingServiceCTARequest,
) =>
  apiClient
    .post<CreateParkingServiceCTAResponse>(
      `/v2/parking_services/${request.serviceId}/call_to_actions`,
      request,
    )
    .then((res) => res.data.data);

export const removeParkingServiceCTA = (
  request: RemoveParkingServiceCTARequest,
) =>
  apiClient
    .delete<RemoveParkingServiceCTAResponse>(
      `/v2/parking_services/${request.serviceId}/call_to_actions/${request.callToActionId}`,
    )
    .then((res) => res.data.data);

export const disableParkingService = (serviceId: string) =>
  apiClient
    .post<DisableParkingServiceResponse>(
      `/v2/parking_services/${serviceId}/disable`,
    )
    .then((res) => res.data.data);

export const enableParkingService = (serviceId: string) =>
  apiClient
    .post<EnableParkingServiceResponse>(
      `/v2/parking_services/${serviceId}/enable`,
    )
    .then((res) => res.data.data);

export const addParkingServiceImage = (
  request: AddParkingServiceImageRequest,
) =>
  apiClient
    .post<AddParkingServiceImageResponse>(
      `/v2/parking_services/${request.serviceId}/images`,
      request.file,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )
    .then((res) => res.data.data);

export const removeParkingServiceImage = (
  request: RemoveParkingServiceImageRequest,
) =>
  apiClient
    .delete<RemoveParkingServiceImageResponse>(
      `/v2/parking_services/${request.serviceId}/images/${request.imageId}`,
    )
    .then((res) => res.data.data);

export const getParkingServiceImage = (
  request: GetParkingServiceImageRequest,
) =>
  apiClient
    .get<GetParkingServiceImageResponse>(
      `/v2/parking_services/${request.serviceId}/images/${request.imageId}`,
    )
    .then((res) => res.data.data);

export const updateParkingServiceOperationHours = (
  request: UpdateParkingServiceOperationHoursRequest,
) =>
  apiClient
    .put<UpdateParkingServiceOperationHoursResponse>(
      `/v2/parking_services/${request.serviceId}/operation_hours`,
      request,
    )
    .then((res) => res.data.data);

export const removeParkingServiceOperationHours = (serviceId: string) =>
  apiClient
    .delete<RemoveParkingServiceOperationHoursResponse>(
      `/v2/parking_services/${serviceId}/operation_hours`,
    )
    .then((res) => res.data.data);

export const updateParkingServiceParkingRates = (
  request: UpdateParkingServiceParkingRatesRequest,
) =>
  apiClient
    .put<UpdateParkingServiceParkingRatesResponse>(
      `/v2/parking_services/${request.serviceId}/parking_rates`,
      request,
    )
    .then((res) => res.data.data);

export const updateParkingServiceParkingSpaces = (
  request: UpdateParkingServiceParkingSpacesRequest,
) =>
  apiClient
    .put<UpdateParkingServiceParkingSpacesResponse>(
      `/v2/parking_services/${request.serviceId}/parking_spaces`,
      request,
    )
    .then((res) => res.data.data);

export const pauseParkingService = (serviceId: string) =>
  apiClient
    .post<PauseParkingServiceResponse>(
      `/v2/parking_services/${serviceId}/pause`,
    )
    .then((res) => res.data.data);

export const removeParkingService = (serviceId: string) =>
  apiClient.delete(`/v2/parking_services/${serviceId}`);

export const updateParkingServicePaymentMethods = (
  request: UpdateParkingServicePaymentMethodsRequest,
) =>
  apiClient
    .put<UpdateParkingServicePaymentMethodsResponse>(
      `/v2/parking_services/${request.serviceId}/payment_methods`,
      request,
    )
    .then((res) => res.data.data);

export const updateParkingServiceTags = (
  request: UpdateParkingServiceTagsRequest,
) =>
  apiClient
    .put<UpdateParkingServiceTagsResponse>(
      `/v2/parking_services/${request.serviceId}/tags`,
      request,
    )
    .then((res) => res.data.data);

export const updateParkingServiceStoreIds = (
  request: UpdateParkingServiceStoreIdsRequest,
) =>
  apiClient
    .put<UpdateParkingServiceStoreIdsResponse>(
      `/v2/parking_services/${request.serviceId}/stores`,
      request,
    )
    .then((res) => res.data.data);
